import React, { useState } from 'react';
import { useDisabledWidget } from '@wix/chat-widget-common-widgets';
import { Box, Button } from '@wix/design-system';
import { useUouLanguage } from '../../../hooks/useUouLanguage';
import { ConnectCalendarModal } from '../../ConnectCalendarModal/ConnectCalendarModal';
import { AssistantWidgetComponent } from '../types';

export const CONNECT_CALENDAR_WIDGET = 'CONNECT_CALENDAR_WIDGET';

export const ConnectCalendarWidget: AssistantWidgetComponent = ({ context, data }) => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const language = useUouLanguage();
  const { send, assistantName, refetchConnectionStatus } = context;
  const { areControlsDisabled } = useDisabledWidget({ widgetName: CONNECT_CALENDAR_WIDGET, context, config: data.config });

  return (
    <Box direction="vertical" width="100%">
      <Box direction="vertical" gap="8px">
        <Box direction="horizontal" gap={2} marginTop={2}>
          <Button size="small" onClick={() => setIsConnectModalOpen(true)} disabled={areControlsDisabled}>
            {language.ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_CTA()}
          </Button>
          <Button
            size="small"
            onClick={() => send(language.ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_MESSAGE())}
            priority="secondary"
            disabled={areControlsDisabled}
          >
            {language.ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_SKIP_CTA()}
          </Button>
          <ConnectCalendarModal
            assistantName={assistantName}
            isOpen={isConnectModalOpen}
            onClose={() => setIsConnectModalOpen(false)}
            onAuthSuccess={() => {
              send(language.ASA_STANDALONE_CONNECT_CALENDAR_WIDGET_CONNECT_MESSAGE());
              refetchConnectionStatus();
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
